export default __webpack_public_path__ + "static/4erBoxen.bg-35822b001d881af02127ad1e97985bee.jpg";